module.exports = __webpack_public_path__ + "img/yiyuan.2257582b.png";